var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.75C10.4962 15.7499 11.9501 15.2529 13.1333 14.337C14.3164 13.4211 15.1619 12.1382 15.537 10.6898M9 15.75C7.50376 15.7499 6.04991 15.2529 4.86673 14.337C3.68356 13.4211 2.83806 12.1382 2.463 10.6898M9 15.75C10.8638 15.75 12.375 12.7275 12.375 9C12.375 5.2725 10.8638 2.25 9 2.25M9 15.75C7.13625 15.75 5.625 12.7275 5.625 9C5.625 5.2725 7.13625 2.25 9 2.25M15.537 10.6898C15.6758 10.1498 15.75 9.5835 15.75 9C15.7519 7.83908 15.4529 6.69749 14.8823 5.6865M15.537 10.6898C13.5369 11.7985 11.2869 12.3786 9 12.375C6.6285 12.375 4.40025 11.7638 2.463 10.6898M2.463 10.6898C2.32106 10.1377 2.2495 9.56998 2.25 9C2.25 7.79625 2.565 6.66525 3.11775 5.6865M9 2.25C10.1972 2.2495 11.3729 2.56752 12.4066 3.17142C13.4403 3.77533 14.2948 4.64338 14.8823 5.6865M9 2.25C7.80282 2.2495 6.62706 2.56752 5.59336 3.17142C4.55966 3.77533 3.70523 4.64338 3.11775 5.6865M14.8823 5.6865C13.2493 7.10095 11.1604 7.87811 9 7.875C6.7515 7.875 4.695 7.05 3.11775 5.6865",
    stroke: "#525355",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackGlobe);
export default __webpack_public_path__ + "static/media/blackGlobe.7b73f17e7605397324650c73aa5e8259.svg";
export { ForwardRef as ReactComponent };